import bodyImage from "../assets/images/body.webp";
import BodyPartPin from "./BodyPartPin";
import { BodyPartPinType } from "./BodyPartsStats";

interface Props {
  className?: string;
  bodyPartsPins: BodyPartPinType[];
}

const BodyModel = ({ className = "", bodyPartsPins }: Props) => {
  return (
    <div
      className={`relative w-full  max-w-[288px] max-h-[452px] 1920px:max-h-[650px] ${className}`}
    >
      <img
        src={bodyImage}
        className="w-full h-full object-contain z-[-1]"
        alt="Test"
      />
      {bodyPartsPins?.map((pin, i) => (
        <BodyPartPin className="min-w-[150px]" key={i} variant={2} {...pin} />
      ))}
    </div>
  );
};

export default BodyModel;
